// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Berkshire+Swash&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/sansation);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base styles */

html, body {
    height: 100%;
    width: 100%;
    margin: 0;
    overflow-x: hidden;
    font-family: "Sansation";
}

.animate-gradient-text {
    background-image: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
    background-size: 200%;
    font-size: 36px; /* Increased font size */
    -webkit-text-fill-color: transparent;
    -webkit-background-clip: text;
    background-clip: text;
    animation: animated-gradient 5s ease infinite;
}

@keyframes animated-gradient {
    0%,
    100% {
        background-position: 0 50%;
    }
    50% {
        background-position: 100% 50%;
    }
}

#statbox {
    margin-top: 20px;
    text-align: center;
    padding: 20px; /* Added padding for better spacing */
    margin-bottom: 20px;
}

#statbox h1 {
    font-size: 28px; /* Adjusted heading size */
}

.chart-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0; /* Added margin for spacing */
    transition: transform 0.3s;
}

.chart-container:hover {
    transform: scale(1.05); /* Slight zoom on hover */
}

.rating-stars {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

/* Star icon styles, keeping it plain golden */
.star-icon {
    color: #F7A115; /* Golden star color */
    font-size: 60px; /* Increased star size */
    vertical-align: middle;
}

/* Responsive adjustments */
@media screen and (max-width: 500px) {
    #statbox {
        padding: 10px; /* Less padding on smaller screens */
    }

    .animate-gradient-text {
        font-size: 24px; /* Reduced font size for smaller screens */
    }

    .star-icon {
        font-size: 40px; /* Smaller star size for mobile */
    }

    #chartdiv {
        width: 90vw; /* Responsive width adjustment for small screens */
        height: 60vh; /* Smaller height for mobile screens */
    }
}

/* Additional responsive design for small screens */
@media screen and (max-width: 500px) {
    .chart-container {
        flex-direction: column;
        width: 90%; /* Responsive width */
        margin: 0 auto; /* Centering the chart */
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/stats.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAIhB;IACI,YAAY;IACZ,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,6EAA6E;IAC7E,qBAAqB;IACrB,eAAe,EAAE,wBAAwB;IACzC,oCAAoC;IACpC,6BAA6B;IAC7B,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI;;QAEI,0BAA0B;IAC9B;IACA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa,EAAE,qCAAqC;IACpD,mBAAmB;AACvB;;AAEA;IACI,eAAe,EAAE,0BAA0B;AAC/C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc,EAAE,6BAA6B;IAC7C,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB,EAAE,yBAAyB;AACrD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA,8CAA8C;AAC9C;IACI,cAAc,EAAE,sBAAsB;IACtC,eAAe,EAAE,wBAAwB;IACzC,sBAAsB;AAC1B;;AAEA,2BAA2B;AAC3B;IACI;QACI,aAAa,EAAE,oCAAoC;IACvD;;IAEA;QACI,eAAe,EAAE,0CAA0C;IAC/D;;IAEA;QACI,eAAe,EAAE,iCAAiC;IACtD;;IAEA;QACI,WAAW,EAAE,kDAAkD;QAC/D,YAAY,EAAE,sCAAsC;IACxD;AACJ;;AAEA,mDAAmD;AACnD;IACI;QACI,sBAAsB;QACtB,UAAU,EAAE,qBAAqB;QACjC,cAAc,EAAE,wBAAwB;IAC5C;AACJ","sourcesContent":["/* Base styles */\r\n@import url('https://fonts.googleapis.com/css2?family=Berkshire+Swash&display=swap');\r\n@import url('https://fonts.cdnfonts.com/css/sansation');\r\n\r\nhtml, body {\r\n    height: 100%;\r\n    width: 100%;\r\n    margin: 0;\r\n    overflow-x: hidden;\r\n    font-family: \"Sansation\";\r\n}\r\n\r\n.animate-gradient-text {\r\n    background-image: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);\r\n    background-size: 200%;\r\n    font-size: 36px; /* Increased font size */\r\n    -webkit-text-fill-color: transparent;\r\n    -webkit-background-clip: text;\r\n    background-clip: text;\r\n    animation: animated-gradient 5s ease infinite;\r\n}\r\n\r\n@keyframes animated-gradient {\r\n    0%,\r\n    100% {\r\n        background-position: 0 50%;\r\n    }\r\n    50% {\r\n        background-position: 100% 50%;\r\n    }\r\n}\r\n\r\n#statbox {\r\n    margin-top: 20px;\r\n    text-align: center;\r\n    padding: 20px; /* Added padding for better spacing */\r\n    margin-bottom: 20px;\r\n}\r\n\r\n#statbox h1 {\r\n    font-size: 28px; /* Adjusted heading size */\r\n}\r\n\r\n.chart-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin: 20px 0; /* Added margin for spacing */\r\n    transition: transform 0.3s;\r\n}\r\n\r\n.chart-container:hover {\r\n    transform: scale(1.05); /* Slight zoom on hover */\r\n}\r\n\r\n.rating-stars {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-top: 20px;\r\n}\r\n\r\n/* Star icon styles, keeping it plain golden */\r\n.star-icon {\r\n    color: #F7A115; /* Golden star color */\r\n    font-size: 60px; /* Increased star size */\r\n    vertical-align: middle;\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media screen and (max-width: 500px) {\r\n    #statbox {\r\n        padding: 10px; /* Less padding on smaller screens */\r\n    }\r\n\r\n    .animate-gradient-text {\r\n        font-size: 24px; /* Reduced font size for smaller screens */\r\n    }\r\n\r\n    .star-icon {\r\n        font-size: 40px; /* Smaller star size for mobile */\r\n    }\r\n\r\n    #chartdiv {\r\n        width: 90vw; /* Responsive width adjustment for small screens */\r\n        height: 60vh; /* Smaller height for mobile screens */\r\n    }\r\n}\r\n\r\n/* Additional responsive design for small screens */\r\n@media screen and (max-width: 500px) {\r\n    .chart-container {\r\n        flex-direction: column;\r\n        width: 90%; /* Responsive width */\r\n        margin: 0 auto; /* Centering the chart */\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
